import { PaperPlaneSkyblue } from "components/icons/PaperPlaneSkyblue";
import { RocketPurpleAnimate } from "components/icons/RocketPurpleAnimate";
import { PlanCard } from "components/SubscriptionModal/PlanCard";

type TaxSubscriptionModalContentProps = {
  price?: number;
  type?: string;
  features?: {
    description: string;
    active: boolean;
  }[];
  description?: string;
  onUpgrade?: () => void;
  hideUpgrade?: boolean;
  containsRadio?: boolean;
  isRadioDisabled?: boolean;
  onRadioChange?: (value: string) => void;
  radioValue?: string;
  isFreePlanActive?: boolean;
  disableFreeplanRadio?: boolean;
};

export const TaxSubscriptionsListContent = ({
  price = 0,
  type = "Free",
  features,
  description,
  onUpgrade,
  hideUpgrade,
  containsRadio,
  isRadioDisabled,
  onRadioChange,
  radioValue,
  isFreePlanActive,
  disableFreeplanRadio,
}: TaxSubscriptionModalContentProps) => {
  const freePlanFeatures = [
    {
      description: "Deadlines & Reminders",
      active: true,
    },
    {
      description: "Includes 3 user seats",
      active: true,
    },
    {
      description: "Access to all tax & compliance filings",
      active: false,
    },
    {
      description: "Dedicated support on chat",
      active: false,
    },
  ];
  return (
    <section className="t-flex t-gap-4">
      <PlanCard
        price={0}
        type="Free"
        buttonText="Subscribe"
        features={freePlanFeatures}
        icon={<PaperPlaneSkyblue />}
        description="Check deadlines and set reminders"
        isButtonDisabled
        hideUpgrade={hideUpgrade}
        containsRadio={containsRadio}
        isRadioDisabled={isRadioDisabled || disableFreeplanRadio}
        onRadioChange={onRadioChange}
        radioValue={radioValue}
        isActive={isFreePlanActive}
      />
      <PlanCard
        price={price}
        billingCycle="year"
        type={type}
        buttonText="Upgrade to Standard"
        features={features || []}
        icon={<RocketPurpleAnimate />}
        description={description || ""}
        onUpgrade={onUpgrade}
        hideUpgrade={hideUpgrade}
        containsRadio={containsRadio}
        isRadioDisabled={isRadioDisabled}
        onRadioChange={onRadioChange}
        radioValue={radioValue}
        isActive={disableFreeplanRadio}
      />
    </section>
  );
};
